import { Component, OnInit } from '@angular/core';
import { AppointmentService, appointmentData } from '../appointment-service/appointment.service';
import { AuthService } from 'src/app/auth-section/auth-service/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppontmentlocalService } from '../appointment-service/appontmentlocal.service';
import { take } from 'rxjs/operators';
import { DoctorsService } from 'src/app/shared/doctor-service/doctors.service';
import { SocketsService } from 'src/app/shared/socket/sockets.service';
import * as moment from 'moment';
@Component({
  selector: 'app-appointment-dashbord',
  templateUrl: './appointment-dashbord.component.html',
  styleUrls: ['./appointment-dashbord.component.css'],
})
export class AppointmentDashbordComponent implements OnInit {
  token: string;
  id: string;
  appArray = [];
  moment:any=moment;
  texts: string[] = [];
  servicesArray = [];
  isData: boolean;
  page: number = 1;
  totalItems = 25;
  doctype:any;
  index: number = 0;
  activePat;
  name:any;
  currentPatNum = 0;
  tempArray: any[] = [];
  cancelledPat = [];
  clinicId: string;
  latePatientArray = [];
  pageSelected = 1;
  limit: any;
  doctorData:any;
  curClinic:any;
  total:any;
  patdata: any=[];
  type:any;
  isActive:boolean = false;
  userToken: string;
  docData;
  profileImage;
  ispending:boolean = true;
  islatepat:boolean = false;
  // patientName:any = [];
  prevnum: number = 0;
  pageofnotpresent:number=1;
  limitofnotpresent:number=10;
  pagesofnotpresent:number=1;

  constructor(
    private appService: AppointmentService,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private appLocalService: AppontmentlocalService,
    private router: Router,
    private doctorService: DoctorsService,
    private socketService: SocketsService
  ) {}

  ngOnInit() {
    this.type = 'Todaypat'
    this.clinicId = JSON.parse(localStorage.getItem('activeClinic'));
    console.log("clinicId -=-=-=-=-=-=-=-=>>>>>>>>.",this.clinicId);
    
    // this.latePatientArray = JSON.parse(localStorage.getItem('latePatient'))
    //   ? JSON.parse(localStorage.getItem('latePatient'))
    //   : [];
    this.getnotPresentPat();

      
      this.authService.authDataSubject.pipe(take(1)).subscribe((auth) => {
        this.token = auth._token;
        this.id = auth._id;
        this.doctype = auth._type;
      });
      this.getSingleDoctor();
    this.getActiveAppointment();
    this.socketService.onNewAppointmentMessage().subscribe((response:any) => {
      console.log("this is socket side",response);
      if(response && response.appointment && response.patientData && this.moment().format('MMMM Do YYYY') == this.moment(response.appointment.appointmentDate).format('MMMM Do YYYY')){
        let appNum = response.appointment.appointmentNumber;
        if(this.currentPatNum > appNum){
          this.checkInclude(response.appointment,this.latePatientArray);
        }else if(this.currentPatNum < appNum){
          let pat = response.appointment;
          pat.patientId = response.patientData;
          this.appArray.push(pat);
        }
        if(this.currentPatNum == appNum){
          this.activePat = response.appointment;
        }
  
        localStorage.setItem(
          'latePatient',
          JSON.stringify(this.latePatientArray)
        );
        console.log(response);
      }
    });

    this.anyNumber()
    console.log("this is appArray",this.appArray);
    console.log(this.currentPatNum,"this is the current");
    
  }
  getSingleDoctor() {
    if(this.doctype == 'DOCTOR'){this.doctorService.getSingleDoctorFromDb(this.id, this.userToken).subscribe(
      (res) => {
        console.log("this is getsingledoctor",res)
        this.doctorData =res;
        this.docData = res;
        this.getDocAppByDate(1, new Date());
        this.docData.experience = this.docData.experience
          ? this.docData.experience
          : 0;
        this.profileImage = 'https://api.doqmatokens.com/' + res.profileImage;
        // this.oninitForm();
        console.log("doctorData -=-=-=-==-=->>>>>",this.doctorData);
        
        this.curClinic = this.doctorData.clinicId.filter(o=>String(o._id) == String(this.clinicId));
        this.currentPatNum = this.curClinic[0].appointmentNumber;
        console.log("this is curclinic Array",this.curClinic);
        // this.getActiveAppointment();
        this.getSingleAppointment();
        this.CheckActive();

        if (res.services.length > 0) {
          this.texts = res.services;
          this.servicesArray = res.services;
        }
      },
      (error) => {
        console.log('error');
        // this.oninitForm();
      }
    );
  }else {
    this.doctorService.getSinglereceptionist(this.id, this.userToken).subscribe(
      (res) => {
        this.doctorData = res;
        this.getDocAppByDate(1, new Date());
        this.docData=res;
        this.docData.experience = this.docData.experience
          ? this.docData.experience
          : 0;
        this.profileImage = 'https://api.doqmatokens.com/' + res.profileImage;
        // this.oninitForm();
        this.curClinic = this.doctorData.clinicId;
        this.currentPatNum = this.curClinic[0].appointmentNumber;
        this.CheckActive();
        this.getSingleAppointment();
        if (res.services.length > 0) {
          this.texts = res.services;
          this.servicesArray = res.services;
        }
      },
      (error) => {
        console.log('error');
        // this.oninitForm();
      }
    );
  }
  }
  CheckActive(){
    console.log("this is curClinic",this.curClinic);
    if(this.curClinic[0].clinicStatus == "ONLINE"){
      this.isActive = true;
    }else{
      this.isActive = false;
    }
  }
  getDocAppByDate(page, appointmentDate) {
    if(this.doctype == "DOCTOR"){
      this.appService
      .getDoctorAppointmentByDateAndStatus(
        appointmentDate,
        this.id,
        this.token,
        page,
        this.totalItems,
        this.clinicId
      )
      .subscribe(
        (res) => {
          let arr1 = res;
          let arr2 = res.appArray.filter((data:any)=>{
            if(data != this.appArray){
              let appArray = this.appArray.concat(data);
              this.appArray = appArray.filter((value,index,self)=>
              index === self.findIndex((t)=>(
                t.appointmentNumber === value.appointmentNumber
              )));
            }
          })
          this.isData = this.appArray.length > 0;
          this.page = res.page;
          this.total = res.total;
          console.log("thhhhh",res);
          console.log("this is apparray",this.appArray);
          this.totalItems = this.totalItems + this.appArray.length;
        },
        (error) => {}
      );
    }else{
      this.appService
      .getDoctorAppointmentByDate(
        appointmentDate,
        this.id,
        this.token,
        page,
        this.clinicId
      )
      .subscribe(
        (res) => {
          let arr1 = res;
          let arr2 = res.appArray.filter((data:any)=>{
            if(data != this.appArray){
              let appArray = this.appArray.concat(data);
              this.appArray = appArray.filter((value,index,self)=>
              index === self.findIndex((t)=>(
                t.appointmentNumber === value.appointmentNumber
              )))
            }
          })
          this.isData = this.appArray.length > 0;
          this.page = res.page;
          this.total = res.total;
          console.log("thhhhh",res);
          console.log("this is apparray",this.appArray);

          this.totalItems = this.totalItems + this.appArray.length;
        },
        (error) => {}
      );
    }
  }
  anyNumber(){
    this.appService.GetrendomToken(this.clinicId,this.token).subscribe((res:any)=>{
      this.patdata = res.data;
      console.log("this is rendom token ========>>>>>>>>",this.patdata);
      // this.name = res.data.patientName;
      // console.log("this is name>>>>>_+_+_+", this.name)
    })
  }

  changerendomNumber(pat:any){
    let text = `Do you want to confirm token number ${pat.appointmentNumber} ?`;
    if(window.confirm(text) == true){
    console.log("this isdata????????",pat)
    this.appService.changeApptStatusByNum(
      this.clinicId,
      pat.appointmentNumber,
      'DONE',
      this.token
      ).subscribe((res:any)=>{
        // alert( `successfully updated appointment number ${res.data.appointmentNumber}`);
        this.anyNumber();
        
      })
    }
  }

  // changeRendomNumber(){
  //   console.log('this is ______' )
  // }


  onNext() {
    if(this.islatepat == true){
      this.currentPatNum = this.prevnum;
      this.appService
        .saveAppointmentStatusAppNum(
          this.activePat.appointmentNumber,
          this.token,
          moment(),
          this.id,
          'DONE',
          this.clinicId
        )
        .subscribe((res) => {
          console.log("successfully update status",res);
          this.islatepat = false;
            this.getSingleAppointment();
            this.appArray = [];
      this.getDocAppByDate(1, moment());
      this.getnotPresentPat();
        });
    }else{
      this.currentPatNum = this.currentPatNum + 1;
      this.getSingleAppointment();
    }
  }
  updateApptNum(){
    let payload = {
      clinicId:this.clinicId,
      apptNumber: this.currentPatNum
    }
    this.doctorService.updateApptNum(payload,this.token).subscribe((data:any)=>{
      console.log("sucessfull",data);
      this.currentPatNum = this.currentPatNum;
    })
  }
async  onCancel() {
  this.ispending = true;
    this.currentPatNum = this.currentPatNum+1;
    this.checkInclude(this.activePat,this.latePatientArray);
    localStorage.setItem('latePatient', JSON.stringify(this.latePatientArray));
    if (this.activePat) {
    await  this.appService
        .saveAppointmentStatusAppNum(
          this.activePat.appointmentNumber,
          this.token,
          moment(),
          this.id,
          'PENDING',
          this.clinicId
        )
        .subscribe(async(res) => {
          console.log("successfully update status",res);
          await  this.getSingleAppointment();
          await  this.getDocAppByDate(1, new Date());
          this.getnotPresentPat();
        });
    }
  }
 async checkInclude(obj, list){
    // function containsObject() {
      let include = await list.filter(o=>o.appointmentNumber == obj.appointmentNumber);
  if(include && include[0] && include.appointmentNumber){

  }else{
    this.latePatientArray.push(obj);
  }
  // }
  }
  onCancelClicked(pat, index) {
    /* this.activePat = pat;

    this.latePatientArray.splice(index, 1);
    localStorage.setItem('latePatient', JSON.stringify(this.latePatientArray));*/
  }
  onchange(type:any){
    // alert(type)
    this.type = type;
    if(this.type == 'notAvailable'){
      this.getnotPresentPat();
    }else{
      this.getDocAppByDate(1,moment())
    }
  }
  getSingleAppointment() {
    console.log(this.clinicId);
    let payload = {};
    if(this.ispending==true){
      payload = {
        appointmentDate: moment(),
      appointmentNumber: this.currentPatNum,
      doctorId: this.id,
      clinicId: this.clinicId,
      pending:true
      }
      this.ispending = false;
    }else if(this.islatepat){
      payload={
        appointmentDate: moment(),
        appointmentNumber: this.currentPatNum,
        doctorId: this.id,
        clinicId: this.clinicId,
        private:true
      }
    }else{
      payload={
        appointmentDate: moment(),
        appointmentNumber: this.currentPatNum,
        doctorId: this.id,
        clinicId: this.clinicId
      }
    }
    console.log("this is payload",payload);
    this.appService
      .getAppointmentByAppNum(
        payload,
        this.token
      )
      .subscribe(
        (res) => {
          this.activePat = res.appointment;
          console.log("i am calling");
          if(!this.islatepat){
            localStorage.setItem('patnum', JSON.stringify(this.currentPatNum));
            this.updateApptNum();
          }
          this.appArray = [];
          this.getDocAppByDate(1, new Date());
        },
        (error) => {
          if (error.status === 422) {
            console.log("this is the error");
            if(!this.islatepat){
              this.appArray = [];
          this.getDocAppByDate(1, new Date());
              this.updateApptNum();
            }
            // this.updateApptNum();
            localStorage.setItem('patnum', JSON.stringify(this.currentPatNum));
            this.activePat = null;
            // this.currentPatNum = this.currentPatNum + 1;
            console.log("this is cuurent num");
            
          }
        }
      );
  }
  
  onpauseAttend(){
    localStorage.removeItem('patnum');
    localStorage.removeItem('latePatient');
    
    var payload={
      clinicId:this.clinicId,
      clinicStatus:"PAUSED"
    }
  this.doctorService.changeClinicStaus(this.clinicId, payload, this.token)
  .subscribe((res:any) => {
    this.curClinic = res.clinics;
    this.getSingleDoctor();
    // this.CheckActive();
    console.log("this is the puse status",res);
    
  });
    }
  onStopAttend() {
    localStorage.removeItem('patnum');
    localStorage.removeItem('latePatient');
    
   var payload = {
      clinicId:this.clinicId,
      clinicStatus: "OFFLINE"
      }
    this.doctorService
      .changeClinicStaus(this.clinicId, payload, this.token)
      .subscribe((res) => {
        this.CheckActive();
        this.router.navigate(['pas/dashboard']);
      });
  }

  onLatePatientClicked(pat) {
    this.islatepat = true;
    console.log(pat,"htsdtdghcgjcyjcyjyjcyj");
    this.prevnum = this.currentPatNum;
    this.currentPatNum = pat.appointmentNumber;
    this.getSingleAppointment();
    this.getnotPresentPat();
  }

  getActiveAppointment() {
    let payload ;
    payload = {
      appointmentDate: new Date(),
      appointmentNumber: this.currentPatNum,
      doctorId: this.id,
      clinicId: this.clinicId,
    }
    this.appService
      .getActiveAppointmentByAppNum(
        payload ,
        this.token
      )
      .subscribe(
        (res) => {
          this.activePat = res.appointment;
          
          // alert();
          localStorage.setItem('patnum', JSON.stringify(this.currentPatNum));
          // this.updateApptNum();
          // this.currentPatNum = this.activePat.appointmentNumber + 1;
        },
        (error) => {
          if (error.status === 422) {
            console.log("this is appointment num",this.activePat);
            localStorage.setItem('patnum', JSON.stringify(this.currentPatNum));
            this.activePat = null;
            // this.currentPatNum = this.currentPatNum + 1;
            // this.updateApptNum();
          }
        }
      );
  }
  onSeeMoreClicked() {
    this.pageSelected = this.pageSelected + 1;
    this.getDocAppByDate(this.pageSelected, new Date());
  }
  getnotPresentPat(){
    this.appService.getnotPresentPat(this.id,this.clinicId,this.token,this.limitofnotpresent,this.pageofnotpresent).subscribe((res:any)=>{
      console.log("this is data of not present patients",res);
      this.pageofnotpresent = res.data.pages;
      this.latePatientArray = res.data.docs;
    })
  }
}